import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { leadSourceQueryKeys } from "./leadSourceQueryKeys";

export async function leadSourceListQueryFn({
  api,
  opts,
}: {
  api: ApiType;
  opts: Parameters<ApiType["leadSourceApi"]["find"]>[0];
}) {
  return (await api.leadSourceApi.find(opts)).data;
}

export function useLeadSourceList({
  api,
  opts,
}: {
  api: ApiType;
  opts: Parameters<ApiType["leadSourceApi"]["find"]>[0];
}) {
  return useQuery({
    queryKey: leadSourceQueryKeys.list(opts),
    queryFn: () => leadSourceListQueryFn({ api, opts }),
  });
}
